import useOngoingOrder from '../../../../hooks/context/useOngoingOrder';
import { WithClassname } from '../../../../types';
import AddressFormatter from '../../../../services/utils/address/AddressFormatter';
import useStore from '../../../../hooks/context/useStore';
import { useMemo } from 'react';
import React from 'react';
import { ShopOutlined, TruckOutlined } from '@ant-design/icons';
import OrderMethodIcon from '../../../../assets/icons/OrderMethodIcon';
import { DeliveryProvider } from '../../../../types/constants';

export default function OrderMethodDetails({ className }: WithClassname) {
  const { storeData } = useStore();
  const { orderData, isDelivery } = useOngoingOrder();

  const address = useMemo(
    () =>
      AddressFormatter.setCountry(
        isDelivery ? orderData.delivery_info.country : storeData.location.country,
      ).format(
        isDelivery
          ? orderData.delivery_info
          : { street_name: storeData.location.address, street_number: '', ...storeData.location },
      ),
    [isDelivery, orderData.delivery_info, storeData.location],
  );

  const deliveryProviderName = {
    [DeliveryProvider.Standalone]: 'Restaurant driver',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
    [DeliveryProvider.FirstDelivery]: 'Uber',
  }[orderData.delivery_info.quote?.provider ?? DeliveryProvider.Standalone];

  return (
    Boolean(orderData.method) && (
      <div className={className}>
        <div className="flex gap-sm">
          {isDelivery ? <TruckOutlined /> : <ShopOutlined />}
          <div>
            <h6 className="uppercase">
              {orderData.method} {isDelivery ? 'to' : 'from'}:
            </h6>
            <p>{address}</p>
          </div>
        </div>
        {isDelivery && (
          <div className="flex gap-sm mt-sm">
            <OrderMethodIcon
              orderMethod={orderData.method}
              deliveryProvider={orderData.delivery_info.quote?.provider}
            />
            <div>
              <h6 className="uppercase">Delivered by:</h6>
              <p>{deliveryProviderName}</p>
            </div>
          </div>
        )}
      </div>
    )
  );
}
